import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/bancos/depositos';
import DepositosForm from './DepositosFormTabs';


const ms2p = (state) => {
  return {
    ...state.deposito,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(DepositosForm);
